// wrap a string/number in brackets or an environment
export default function brackets(content, env = '', left = "", right = "") {
    // add slashes to environment
    if (env) {
        env = "\\" + env;
    }
    // add curly braces on left by default
    if (!left) {
        left = "{";
    }
    // right to match left by default
    if (!right) {
        if (left == "{") {
            right = "}";
        }
        else if (left == "(") {
            right = ")";
        }
        else if (left == "[") {
            right = "]";
        }
    }
    return env + left + String(content) + right;
}
